const DEVICE_TYPES = {
  ALS: 'A',
  BLS: 'B',
  HELI: 'H',
};

export default DEVICE_TYPES;
